export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-medium-114f958984027fa5832f741fb04b6614.eot";